import { capitalCase } from 'change-case';

import FilterEvent from '@/components/modal-select/filters/FilterEvent.js';

export default class Filter {
    constructor(field, label) {
        this.field = field;
        this.label = label || capitalCase(field);
        this.default = null;

        this.handler = ({ items }) => {
            return { items };
        };
    }

    setHandler(callback) {
        this.handler = callback;

        return this;
    }

    captureEvent(capture) {
        return new FilterEvent({ ...capture, filter: this });
    }

    linkQueryBuilder(queryBuilder) {
        this.queryBuilder = queryBuilder;
    }

    clearFilter() {
        this.queryBuilder.removeFilter(this.field);

        this.value = false;
    }

    setDefault(value) {
        this.default = value;
        this.value = value;

        if (value && this.handler && this.queryBuilder) {
            const mockEvent = {
                getAttribute: key => {
                    if (key === 'value') return value;
                    if (key === 'dates') return value;
                    return null;
                },
            };

            this.handler({ filterEvent: mockEvent });
        }

        return this;
    }

    get is_applied() {
        return this.queryBuilder.hasFilter(this.field);
    }
}
